import type { RequestConfig } from '@customTypes/index';
import type { ProfileProgressDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistProfileProgressRequest = {
  profileId: string;
};

export type ArtistProfileProgressParams =
  RequestConfig<ArtistProfileProgressRequest>;

export const artistProfileProgress = async ({
  params,
  config
}: ArtistProfileProgressParams) =>
  api.get<ProfileProgressDto>(
    `/api/profile/progress/artist/${params.profileId}`,
    config
  );
